import React from 'react';
import { Badge } from "../ui/badge.jsx";

export default function TicketsByPriorityTable({ tickets, isLoading }) {
  const priorities = ['critical', 'high', 'medium', 'low'];
  
  const priorityLabels = {
    critical: 'Crítica',
    high: 'Alta',
    medium: 'Média',
    low: 'Baixa'
  };
  
  const priorityColors = {
    critical: 'bg-red-100 text-red-800',
    high: 'bg-orange-100 text-orange-800',
    medium: 'bg-yellow-100 text-yellow-800',
    low: 'bg-blue-100 text-blue-800'
  };
  
  // Contar tickets por prioridade
  const getPriorityCounts = () => {
    if (!tickets || tickets.length === 0) {
      // Dados zerados quando não houver tickets
      return {
        critical: 0,
        high: 0,
        medium: 0,
        low: 0
      };
    }
    
    return tickets.reduce((acc, ticket) => {
      const priority = ticket.priority || 'medium';
      acc[priority] = (acc[priority] || 0) + 1;
      return acc;
    }, {});
  };
  
  const priorityCounts = getPriorityCounts();
  const total = priorities.reduce((sum, priority) => sum + (priorityCounts[priority] || 0), 0);
  
  if (isLoading) {
    return (
      <div className="space-y-4 animate-pulse">
        {priorities.map((priority) => (
          <div key={priority} className="flex items-center justify-between">
            <div className="h-6 w-24 bg-gray-200 rounded"></div>
            <div className="flex-1 mx-4">
              <div className="h-4 w-full bg-gray-100 rounded-full overflow-hidden"></div>
            </div>
            <div className="h-6 w-8 bg-gray-200 rounded"></div>
          </div>
        ))}
      </div>
    );
  }
  
  return (
    <div className="space-y-4">
      {priorities.map((priority) => {
        const count = priorityCounts[priority] || 0;
        const percentage = total > 0 ? Math.round((count / total) * 100) : 0;
        
        return (
          <div key={priority} className="flex items-center justify-between">
            <Badge variant="outline" className={priorityColors[priority]}>
              {priorityLabels[priority] || priority}
            </Badge>
            <div className="flex-1 mx-4">
                                <div className="h-2 w-full bg-gray-100 rounded-full overflow-hidden">
                <div 
                  className={`h-full ${
                    priority === 'critical' ? 'bg-red-500' :
                    priority === 'high' ? 'bg-orange-500' :
                    priority === 'medium' ? 'bg-yellow-500' :
                    'bg-blue-500'
                  }`}
                  style={{ width: `${percentage}%` }}
                ></div>
              </div>
            </div>
            <span className="text-sm font-medium">{count} ({percentage}%)</span>
          </div>
        );
      })}
    </div>
  );
}